import { styled } from '@mui/material/styles';

import { Button } from '../../Button/Button';

export const StyledBulkCloseButton = styled(Button)`
  max-width: fit-content;
  font-size: 12px;
`;
